// test1225
(1225 && 0);
